import React, { useEffect, useState, useRef } from 'react';
import partnerMain from '../../assets/images/partner/partner_main.png';
import partnerMainMobile from '../../assets/images/partner/partner_main_mobile.png';

function PartnerMain() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full flex justify-center bg-gradient-to-r from-[#A240E0] to-[#E483E8] pb-[20px] md:pb-0 overflow-hidden">
      <div className="w-full flex flex-col md:flex-row items-center justify-between">
        {/* 왼쪽 텍스트 */}
        <div
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-end px-2 md:px-[4px] space-y-[16px] md:space-y-[40px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="w-full flex flex-col items-end justify-center">
            <div className="w-fit flex flex-col items-start justify-center px-[20px]">
              <h1 className={`text-[32px] pt-[60px] md:pt-[0px] md:text-[54px] font-pretendard font-bold text-white leading-[140%] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                지금, 폰피쉬와 함께할<br />안경원을 찾습니다 👀
              </h1>
              <p className={`text-[16px] md:text-[22px] font-pretendard font-normal text-white leading-[160%] mt-[36px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                폰피쉬와 함께, 안경원의 매출을 성장시켜보세요.<br />Z세대가 찾는 트렌디한 컬러렌즈,<br />이제 안경원에서도 경험할 수 있습니다.
              </p>
              <p className="text-[14px] md:text-[18px] mr-[20px] md:mr-[0px] font-pretendard font-normal text-white leading-[160%] pt-[20px] md:pt-[120px] flex md:hidden">
                <span className="mr-1">*</span>
                <span className="break-keep">폰피쉬는 '의료기사 등에 관한 법률'에 따라 안경사 면허를 보유한 안경원 원장님만 제휴가 가능합니다.<br />면허 확인 후 제휴가 승인됩니다.</span>
              </p>
              {/* 버튼 영역 - PC는 2+1 구조, 모바일은 세로 */}
              <div className="flex flex-col w-fit md:w-fit pt-[60px] md:pt-[60px] gap-4">
                <div className="flex flex-col md:flex-row gap-4 md:gap-x-6 w-full md:w-fit justify-center md:justify-start">
                  <a href="https://ponpish.notion.site/238d3c74a75880bd95cee736702f8a5f?pvs=105" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto">
                    <button className="bg-white text-black px-10 py-4 rounded-full font-pretendard font-semibold text-[18px] md:text-[20px] leading-[160%] shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] hover:bg-gray-100 transition whitespace-nowrap w-full md:w-auto">
                      신규 파트너 신청하기 →
                    </button>
                  </a>
                  <a href="http://partners-prod.ponpish.co.kr" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto">
                    <button className="bg-white text-black px-10 py-4 rounded-full font-pretendard font-semibold text-[18px] md:text-[20px] leading-[160%] shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] hover:bg-gray-100 transition whitespace-nowrap w-full md:w-auto">
                      파트너 센터 로그인 →
                    </button>
                  </a>
                </div>
                <a href="/about" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto">
                  <button className="bg-black text-white px-10 py-4 rounded-full font-pretendard font-semibold text-[18px] md:text-[20px] leading-[160%] shadow-[inset_0_2px_4px_rgba(255,255,255,0.1)] hover:bg-gray-800 transition whitespace-nowrap w-full md:w-auto">
                    폰피쉬 서비스 소개 →
                  </button>
                </a>
              </div>
              <p className="text-[14px] md:text-[20px] font-pretendard font-normal text-white leading-[160%] pt-[60px] md:pt-[80px] hidden md:flex">
                <span className="mr-1">*</span>
                <span>폰피쉬는 '의료기사 등에 관한 법률'에 따라 안경사 면허를 보유한<br />안경원 원장님만 제휴가 가능합니다. 면허 확인 후 제휴가 승인됩니다.</span>
              </p>
            </div>
          </div>
        </div>
        {/* 오른쪽 이미지 */}
        <div
          className={`w-full md:w-1/2 flex justify-center md:justify-start h-full transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[50px]'} relative z-10`}>
          <div className="w-full md:w-[680px] h-[500px] md:h-[955px] mb-[-72px] md:mb-[-100px] md:mb-0 ml-[0px] md:ml-[60px] mt-[30px] md:mt-0 relative">
            <img src={partnerMainMobile} alt="파트너 메인 이미지" className="w-full h-full object-contain md:hidden" />
            <img src={partnerMain} alt="파트너 메인 이미지" className="w-full h-full object-contain hidden md:block" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default PartnerMain; 